import React from 'react';
import Modal, { ModalProps, showModal } from '../Modal';
import Button from '../Button';
import { getConsultationTypeformUrl } from '../../constants/marketingPage';
import TextLink from '../TextLink';

function SignupRedirectModal({ onClose }: ModalProps) {
  return (
    <Modal title="Get started with TokenTax" onClose={onClose}>
      <div>
        <p className="mb-4">TokenTax is a full-service crypto tax platform and reconciliation firm.</p>

        <p className="mb-6">
          Get started by filling out our new client form. Alternatively you can have a current TokenTax client
          invite you.
        </p>

        <p className="mb-6">
          Learn more about how to get{' '}
          <TextLink
            external
            to="https://help.tokentax.co/en/articles/12010901-invite-your-friends-to-tokentax"
          >
            invited to TokenTax
          </TextLink>
          .
        </p>

        <Button
          onClick={() => {
            window.open(getConsultationTypeformUrl('sign-up-redirect', 'app'), '_blank');
          }}
        >
          Get started
        </Button>
      </div>
    </Modal>
  );
}

export default React.memo(SignupRedirectModal);

export function showSignupRedirectModal() {
  showModal(<SignupRedirectModal />);
}
